import React from "react";
import { connect } from "react-redux";
import Comment from "./components/Comment";
import { Segment } from "semantic-ui-react";
import { loadPostComments } from "../../../../../../actions/postActions";
import Transition from "react-transition-group/Transition";

function CommentsList({ comments, postId, actions }) {
  const isFetching = comments.isFetching;

  // If fetching comments for the first time, just show a loader
  if (isFetching && comments.data.length < 1) {
    return <Segment basic loading size="mini" />;
  }

  const hasNoComments = comments.data.length < 1 && comments.pending.length < 1;

  if (hasNoComments) {
    return <p className="comments-note-text"> No comments yet </p>;
  }

  return (
    <div>
      {getTopListItem(comments, postId, actions.loadMoreComments)}
      {comments.data.map(comment => (
        <Transition
          timeout={{
            enter: 100,
            exit: 500,
          }}
          key={comment._id}
          in={!comment.isDeleted}
          unmountOnExit={true}
        >
          {status => <Comment comment={comment} animationClass={`post-${status}`} />}
        </Transition>
      ))}
      {comments.pending.map((comment, index) => <Comment status={comment.status} comment={comment} key={index} />)}
    </div>
  );
}

function getTopListItem(comments, postId, loadMoreComments) {
  if (comments.isFetching) {
    return <Segment basic loading size="mini" />;
  }
  if (comments.hasMore) {
    return (
      <div className="show-more">
        <a onClick={() => loadMoreComments(postId, comments.pagingToken)}>Show more</a>
      </div>
    );
  }
  return null;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadMoreComments: (postId, pagingToken) => dispatch(loadPostComments(postId, { pagingToken })),
    },
  };
}

export default connect(null, mapDispatchToProps)(CommentsList);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentsList/index.js